import React from "react";
import { HashRouter, Route, Switch, Redirect } from "react-router-dom";
import { withRouter } from 'react-router';
// components
import Layout from "./Layout";
import MainPage from "../pages/Surveylink/MainPage";

// pages
import Login from "../pages/Login/Login";
import Ssologin from "../pages/Ssologin/Ssologin";
import NotFoundPage from "../pages/NotFoundPage";

import AssessmentLogin from "../pages/Login/AssessmentLogin";
import AssessmentPage from "../pages/Surveylink/AssessmentPage";
import LeadershipPage from "../pages/Surveylink/LeadershipPage";
import AssessmentLoginByOTP from "../pages/Login/AssessmentLoginByOTP";
import ResponseLoginByOTP from "../pages/Login/ResponseLoginByOTP";
import ResponseDashboard from "../pages/ResponsePanel/ResponsePanel";


import InsightOverview from "../pages/Insight/Overview/Overview";
import InsightDashboard from "../pages/Insight/Dashboard/Dashboard";
import LoginAdmin from "../pages/Login/LoginAdmin";
import LoginCode from "../pages/Login/LoginCode";
import InboxActivity from "../pages/Insight/Activities/InboxActivity";
import ReadingCaseStudy from "../pages/Insight/Activities/ReadingCaseStudy";
import RolePlayPreparation from "../pages/Insight/Activities/RolePlayPreparation";
import MeetingLinks from "../pages/Insight/Activities/MeetingLinks";
import Surveydesign from "../pages/Insight/Surveydesign/Surveydesign";

import AdminHome from "../pages/InsightAdmin/AdminHome";

import CaseStudyTable from "../pages/InsightAdmin/CaseStudy/CaseStudyTable";
import CaseStudyDetails from "../pages/InsightAdmin/CaseStudy/CaseStudyDetails";

import RolePlayTable from "../pages/InsightAdmin/RolePlay/RolePlayTable";
import RolePlayDetails from "../pages/InsightAdmin/RolePlay/RolePlayDetails";
import MailLibrary from "../pages/InsightAdmin/MailLibrary/MailLibrary";
import Employees from "../pages/InsightAdmin/Employees/Employees";
import AssignTask from "../pages/InsightAdmin/AssignTask/AssignTask";
import QuestionMain from "../pages/Insight/Survey/QuestionMain";
import PDFUpload from "../pages/Insight/Activities/PDFUpload";
import ResponseStatus from "../pages/InsightAdmin/ResponseStatus/ResponseStatus";
import ActivityStatus from "../pages/InsightAdmin/ActivityStatus/ActivityStatus";
import AssignCoach from "../pages/InsightAdmin/AssignCoach/AssignCoach";
import CoachPanel from "../pages/Insight/CoachPanel/CoachPanel";
import Replies from "../pages/InsightAdmin/MailLibrary/Replies";

// context
//import { useUserState } from "../context/UserContext";

export default function App() {

  // global
  //var { isAuthenticated } = useUserState();
  // <Route path="/v2/:id" component={withRouter(MainPage)} />



  return (
    <HashRouter>
      <Switch>
        <Route exact path="/" render={() => <Redirect to="/insight/signin" />} />
        {/* <PublicRoute path="/survey" component={withRouter(Layout)} /> */}
        <Route path="/v2/:id" component={withRouter(MainPage)} />
        <Route path="/login/:id" component={withRouter(Login)} />
        {/* <Route path="/ssologin" component={withRouter(Login)} /> */}

        <Route path="/ssologin" component={withRouter(Ssologin)} />

        <Route path="/notfound" component={withRouter(NotFoundPage)} />

        {/* <Route path="/assessment/login" component={withRouter(AssessmentLogin)} /> */}
        <Route path="/assessment/signin" component={withRouter(AssessmentLoginByOTP)} />

        <Route path="/assessment/survey" component={withRouter(AssessmentPage)} />
        <Route path="/assessment/leadership" component={withRouter(LeadershipPage)} />

        <Route path="/response/signin/:id" component={withRouter(ResponseLoginByOTP)} />
        <Route path="/response/home/:id" component={withRouter(ResponseDashboard)} />

        <Route path="/v3/:id/:idc" component={withRouter(MainPage)} />

        <Route path="/insight/signin" component={withRouter(LoginCode)} />
        <Route path="/insight/adminlogin" component={withRouter(LoginAdmin)} />


        <Route path="/insight/overview" component={withRouter(InsightOverview)} />
        <Route path="/insight/dashboard" component={withRouter(InsightDashboard)} />
        <Route path="/insight/meeting/:name" component={withRouter(MeetingLinks)} />
        <Route path="/insight/casestudy/" component={withRouter(ReadingCaseStudy)} />
        <Route path="/insight/mailbox/" component={withRouter(InboxActivity)} />
        <Route path="/insight/roleplay/" component={withRouter(RolePlayPreparation)} />
        <Route path="/insight/survey/" component={withRouter(QuestionMain)} />
        <Route path="/insight/upload/" component={withRouter(PDFUpload)} />
        <Route path="/insight/surveydesign" component={withRouter(Surveydesign)} />
        <Route path="/insight/coachpanel" component={withRouter(CoachPanel)} />




        <Route path="/insightadmin/overview/" component={withRouter(AdminHome)} />

        <Route path="/insightadmin/casestudy/" component={withRouter(CaseStudyTable)} />
        <Route path="/insightadmin/casestudydetails/:id" component={withRouter(CaseStudyDetails)} />

        <Route path="/insightadmin/roleplay/" component={withRouter(RolePlayTable)} />
        <Route path="/insightadmin/roleplaydetails/:id" component={withRouter(RolePlayDetails)} />

        <Route path="/insightadmin/maillibrary" component={withRouter(MailLibrary)} />
        <Route path="/insightadmin/replies" component={withRouter(Replies)} />

        <Route path="/insightadmin/employees" component={withRouter(Employees)} />

        <Route path="/insightadmin/assign" component={withRouter(AssignTask)} />
        <Route path="/insightadmin/response/:id" component={withRouter(ResponseStatus)} />
        <Route path="/insightadmin/status/:id" component={withRouter(ActivityStatus)} />

        <Route path="/insightadmin/coach" component={withRouter(AssignCoach)} />





      </Switch>
    </HashRouter>
  );

}
